import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { DeepBI } from "../../../integrations";
import styles from "./styles.m.css";

export default function GooglePreference({ story }) {
  const handleClick = e => {
    e.stopPropagation();
    DeepBI.pingPaywallEventTrigger(story, "GooglePreferenceClicked");
  };

  useEffect(() => {
    DeepBI.pingPaywallEventTrigger(story, "GooglePreferenceButtonEnabled");
  }, []);

  return (
    <div className={styles["google-preference-container"]}>
      <a
        href="https://www.google.com/preferences/source?q=vikatan.com"
        target="_blank"
        rel="noopener noreferrer"
        className={styles["google-preference-btn"]}
        onClick={handleClick}
      >
        <img
          src="https://media.vikatan.com/vikatan/2026-02-06/8jdk7x1o/google-preferred-badge.png?q=100&w=300"
          alt="Google Preference"
          className={styles["google-preference-img"]}
        />
      </a>
    </div>
  );
}

GooglePreference.propTypes = {
  story: PropTypes.shape()
};
